<template>
  <div>
    <issue-order ref="orders" :type="type" @clearDetails="clearDetails" @issue="issue" @restore="restore" @showDetails="showDetails"/>
    <issue-detail ref="details" :type="type"/>
  </div>
</template>

<script>
import IssueOrder from '@/views/outbound/issue/IssueOrder.vue'
import IssueDetail from '@/views/outbound/issue/IssueDetail.vue'

export default {
  name: 'IssueTemplate',
  components: { IssueOrder, IssueDetail },
  props: {
    type: { type: String, default: '' }
  },
  data() {
    return {}
  },
  methods: {
    refresh() {
      this.$refs.orders.refresh()
    },
    issue(row) {
      this.$emit('issue', row.order.id)
    },
    restore(row) {
      this.$emit('restore', row.order.id)
    },
    showDetails(row) {
      this.$refs.details.refresh(row.order.id)
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>